module.exports = __webpack_public_path__ + "img/trc_quote.3d60a934.png";